/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
Shopify.theme.jsSidebar = {
  init: function() {

    const facetedFilterForm = document.querySelector('[data-faceted-filter-form]')
    if (facetedFilterForm) {
      facetedFilterForm.addEventListener('change', e => {
        if (e.target.type == 'number') return;
        facetedFilterForm.submit();
      });
    }

    const openSidebarBlocks = document.querySelectorAll('[data-sidebar-block__toggle="open"]');

    openSidebarBlocks.forEach(function(block){
      Shopify.theme.jsSidebar.openSidebarBlock($(block));
    })


    $('[data-has-toggle-option]').on('click', '[data-sidebar-block__toggle="closed"]', function (e) {

      e.preventDefault();
      Shopify.theme.jsSidebar.openSidebarBlock($(this));
    });

    $('[data-has-toggle-option]').on('click', '[data-sidebar-block__toggle="open"]', function(e) {

      e.preventDefault();
      Shopify.theme.jsSidebar.closeSidebarBlock($(this));
    });

    if ($('[data-product-sidebar]').length) {
      $('.section--has-sidebar-option').addClass('has-sidebar-enabled');
      $('.section--has-sidebar-option').removeClass('has-sidebar-disabled');
    } else {
      $('.section--has-sidebar-option').removeClass('has-sidebar-enabled');
      $('.section--has-sidebar-option').addClass('has-sidebar-disabled');

    }

  },
 openSidebarBlock: function ($toggleBtn) {
  const $parentBlock = $toggleBtn.closest('.sidebar__block');
  const $content = $parentBlock.find('[data-sidebar-block__content--collapsible]');

  // 1) Close all other blocks
  $('.sidebar__block').not($parentBlock).each(function () {
    const $block = $(this);

    $block
      .removeClass('is-active')
      .attr('aria-expanded', false);

    // Make sure their toggle button is marked as closed
    $block
      .find('[data-sidebar-block__toggle]')
      .attr('data-sidebar-block__toggle', 'closed');

    $block
      .find('[data-sidebar-block__content--collapsible]')
      .stop(true, true)
      .slideUp();
  });

  // 2) Open the clicked block (NO toggle logic here)
  $toggleBtn.attr('data-sidebar-block__toggle', 'open');

  $parentBlock
    .addClass('is-active')
    .attr('aria-expanded', true);

  $content
    .stop(true, true)
    .slideDown();
},

closeSidebarBlock: function ($toggleBtn) {
  const $parentBlock = $toggleBtn.closest('.sidebar__block');
  const $content = $parentBlock.find('[data-sidebar-block__content--collapsible]');

  $toggleBtn.attr('data-sidebar-block__toggle', 'closed');

  $parentBlock
    .removeClass('is-active')
    .attr('aria-expanded', false);

  $content
    .stop(true, true)
    .slideUp();
},

  unload: function() {
    const $toggleBtn = $('[data-sidebar-block__toggle]');
    $toggleBtn.off();
  }
}

/******/ })()
;